// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_me-2";
export var interactiveWrapper = "_me-0";
export var shippingHoverPreview = "_me-4";
export var summaryBadgeTrigger = "_me-1";
export var widgetHoverPreviewList = "_me-3";
export var widgetPreviewScale = "_me-5";